<script setup lang="ts"></script>

<template>
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1691_7774)">
      <path
        d="M7.00008 1.66669C10.2201 1.66669 12.8334 4.28002 12.8334 7.50002C12.8334 10.72 10.2201 13.3334 7.00008 13.3334C3.78008 13.3334 1.16675 10.72 1.16675 7.50002C1.16675 4.28002 3.78008 1.66669 7.00008 1.66669ZM7.00008 12.1667C9.57841 12.1667 11.6667 10.0784 11.6667 7.50002C11.6667 4.92169 9.57841 2.83335 7.00008 2.83335C4.42175 2.83335 2.33341 4.92169 2.33341 7.50002C2.33341 10.0784 4.42175 12.1667 7.00008 12.1667ZM9.06275 4.61252L9.88758 5.43735L7.00008 8.32485L6.17525 7.50002L9.06275 4.61252Z"
        fill="#606060"
      />
    </g>
    <defs>
      <clipPath id="clip0_1691_7774">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
